import { SvgIcon, SvgIconProps } from '@mui/material';

interface DefaultProfileScoreCategoryIconProps extends SvgIconProps {
  letter: string;
}

const DefaultProfileScoreCategoryIcon = ({
  letter,
  ...props
}: DefaultProfileScoreCategoryIconProps) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      sx={{ width: 24, height: 24, fill: 'none' }}
      viewBox="0 0 24 24"
      {...props}
    >
      <text
        x="12"
        y="12"
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="14"
        fontFamily="Arial"
        fill="#727F93"
        fontWeight="bold"
      >
        {letter.toUpperCase()}
      </text>
    </SvgIcon>
  );
};

export default DefaultProfileScoreCategoryIcon;
